module.exports = __webpack_public_path__ + "static/media/stepper-checkmark.5f9ccfab.svg";